/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import classNames from 'classnames';
import Icon from '@react/react-spectrum/Icon';
import PropTypes from 'prop-types';
import React from 'react';
import './ShellAvatar.scss';

export default function ShellAvatar({large, src}) {
  const [imageError, setImageError] = React.useState(false);

  return (
    <figure
      className={classNames('spectrum-Shell-avatar', {
        'spectrum-Shell-avatar--large': large
      })}
    >
      {!src || imageError ? (
        <Icon size="M">
          <svg viewBox="0 0 64 64" x="0px" y="0px">
            <g>
              <circle cx="32" cy="32" fill="#00D8AF" r="32" />
              <path d="M21.5,62.2C4.8,56.5-4,38.2,1.8,21.5S25.8-4,42.5,1.8" fill="#00A888" />
            </g>
          </svg>
        </Icon>
      ) : (
        <img
          alt="User Profile"
          onError={() => setImageError(true)}
          src={src}
        />
      )}
    </figure>
  );
}

ShellAvatar.propTypes = {
  /** Indicate where to display the avatar as large image. */
  large: PropTypes.bool,
  /** File path to the image's source. */
  src: PropTypes.string
};

ShellAvatar.defaultProps = {
  large: false,
  src: ''
};
